module.exports = __webpack_public_path__ + "static/james-portrait-c40ef890264ddd6dbf1fc20315c7526f.jpg";